module.exports = "/_next/static/images/harpers_bazaar-2684d0be306c37010486447d73b128c7.png";